<div class="top-navbar">
  <div class="top-nav-content">
    <span 
      class="top-nav-title"
      (click)="redirectToHomePage()">
      MATRIS NEO  <span style="font-size: 0.6em;"> {{header}} {{version}}</span>
    </span>

    
  </div>
</div>

<!-- Menubar Skeleton -->
<p-menubar *ngIf="showMenubarSkeleton">
  <ng-template pTemplate="start">
    <div class="dekstop-skeleton flex align-items-center">
    
      <p-skeleton class="custom-skeleton" width="9rem" height="1.6rem"></p-skeleton>
      <p-skeleton class="custom-skeleton" width="9rem" height="1.6rem"></p-skeleton>
      <p-skeleton class="custom-skeleton" width="9rem" height="1.6rem"></p-skeleton>
      <p-skeleton class="custom-skeleton" width="9rem" height="1.6rem"></p-skeleton>
    </div>
    <div class="mobile-skeleton flex align-items-center">
    <p-skeleton class="custom-skeleton" shape="circle" size="2rem"></p-skeleton>
    </div>

  </ng-template>
  <ng-template pTemplate="end">
    <p-button (click)="op.toggle($event)" styleClass="menu-button" class="pr-2"><i class="pi pi-user"
        style="font-size: 1.2rem;"></i></p-button>
    <p-overlayPanel #op>
      <div>
        <span class="pi pi-user"></span> &nbsp; <span style="font-family: 'Scania Sans Condensed';"
          class="userinfo-font">{{username}}</span>
      </div>
      <br>
      <div>
        <span class="pi pi-building"></span> &nbsp; <span style="font-family: 'Scania Sans Condensed';"
          class="userinfo-font">{{companyName}}</span>
      </div>
    </p-overlayPanel>
  </ng-template>
</p-menubar>

<button 
  pButton 
  class="p-button-rounded guided-tour-btn"
  (click)="onGuidedTourBtnClick()"
  [pTooltip]="tourTooltip" 
  tooltipPosition="left">
  <img src="assets/guided_con.png" alt="Tips & Tricks" style="width: 62px; height: 62px;" />
</button>



<!-- Menubar -->
<p-menubar *ngIf="!showMenubarSkeleton" [model]="items" styleClass="testing-class">
  <ng-template pTemplate="start">

  </ng-template> &nbsp; &nbsp;
  <ng-template pTemplate="end">
  
    <p-button  [pTooltip]="showAlert ? 'Please update your profile' : 'Profile'" tooltipPosition="bottom" (click)="op.toggle($event)" 
      styleClass="menu-button" class="pr-2" [ngClass]="{'profile-alert-button': showAlert}">
      <i class="pi pi-user" style="font-size: 1.2rem;"></i>
    </p-button>
    <p-overlayPanel #op>
      <div>
        <span class="pi pi-user"></span> &nbsp; <span style="font-family: 'Scania Sans Condensed';"
          class="userinfo-font">{{username}}</span>
      </div>
      <br>
      <div>
        <span class="pi pi-building"></span> &nbsp; <span style="font-family: 'Scania Sans Condensed';"
          class="userinfo-font">{{companyName}}</span>
      </div>
      <br>
      <div>
        <span class="pi pi-comments"></span> &nbsp; <span (click)="onFeedbackClick()"
          style="font-family: 'Scania Sans Condensed'; cursor: pointer;" class="userinfo-font">Report an issue
        </span>
      </div>
      <div>
        <neo-matris-button [buttonText]="'Edit Profile'" (buttonClick)="onEditProfileClick()" 
        [ngClass]="{'profile-alert-button': showAlert}" [pTooltip]="showAlert ? 'Please update your profile' : ''"
        [buttonStyle]="{'height': '20%','width':'100%', 'margin-top':'10px', 'margin-right':'10px'}">
        </neo-matris-button>
      </div>
    </p-overlayPanel>


  </ng-template>

</p-menubar>



<!-- Show banner based on AWS App Config Configuration -->
<p-messages *ngIf="isBannerMessageVisible" [(value)]="messages" />